export default __webpack_public_path__ + "static/media/concervet.0b18c6b6.jpg";